module.exports = __webpack_public_path__ + "static/media/logo.77d8f6be.png";